import React from 'react';
import { SelectInput } from 'react-admin';
import { useFormContext } from 'react-hook-form';
import {
  getClassificationFromSource,
  getInheritedSettings,
  getSourceAndLabel,
  updateProRateCents,
} from '../PositionRateSettingsForm.utils';

type Props = {
  source: string;
  inheritedSettings: any;
};

export const RateStructureSelect = ({ source, inheritedSettings }: Props) => {
  const { setValue, watch } = useFormContext();
  const mergedSettings = getInheritedSettings({ source, inheritedSettings, watch });
  const { level } = getClassificationFromSource(source);
  const { field } = getSourceAndLabel(source);
  const isW2 = source.includes('w2');
  const isLocationLevel = level === 'location_position_rate_setting';

  let applicableField = field;

  if (source.includes('w2.local')) {
    applicableField = 'base_margin_percent_w2';
  }

  const marginPercent = watch(`${source}.${applicableField}`);

  const { blended_rate_cents, charge_rate_cents } = mergedSettings;

  function onChangeRateStructure(event: React.ChangeEvent<HTMLInputElement>) {
    const selectedValue = event.target.value;

    if (isW2) {
      setValue(`${level}.w2.local.use_blended_rate`, selectedValue);
      setValue(`${level}.w2.travel.use_blended_rate`, selectedValue);
    }

    updateProRateCents({
      setValue,
      watch,
      source,
      rateCents: selectedValue && !isLocationLevel ? blended_rate_cents : charge_rate_cents,
      inheritedSettings,
      baseMarginPercent: marginPercent,
    });
  }

  return (
    <SelectInput
      source={`${source}.use_blended_rate`}
      choices={[
        { id: false, name: '8 hour rate' },
        { id: true, name: '12 hour rate' },
      ]}
      label="Rate Structure"
      emptyText="Apply inheritance"
      onChange={onChangeRateStructure}
    />
  );
};
